import moment from 'moment'
import CommonUtils from '@/utils/commonUtils'
import { EtiquettesService } from '../services/EtiquettesService'

export const state = {
  etiquettes: [],
  loading: false,
  date: moment().format('YYYY-MM-DD'),
}
export const mutations = {
  setEtiquettes (currentState, etiquettes) {
    currentState.etiquettes.etiquettes = etiquettes
  },
  setEtiquettesLoading (currentState, bool) {
    currentState.etiquettes.loading = bool
  },
  setEtiquettesDate (currentState, date) {
    currentState.etiquettes.date = date
  },
}
export const actions = {
  setEtiquettesDate ({ commit }, date) {
    commit('setEtiquettesDate', date)
  },
  loadEtiquettes ({ commit, rootState }, clientId) {
    commit('setEtiquettesLoading', true)
    Promise.all([
      EtiquettesService.getAll(clientId, rootState.etiquettes.date),
    ])
      .then(etiquettes => {
        const etiquetesWithCorrectType = etiquettes[0].map((etiquette) => ({
          ...etiquette,
          transforme: CommonUtils.toBoolean(etiquette.transforme),
          printed: CommonUtils.toBoolean(etiquette.ocrModified),
          ingredients: CommonUtils.toBoolean(etiquette.ingredients),
          compositionEau: CommonUtils.toBoolean(etiquette.compositionEau),
          dessication: CommonUtils.toBoolean(etiquette.dessication),
          codeZone: CommonUtils.parseNumber(etiquette.codeZone),
          idCapture: CommonUtils.parseNumber(etiquette.idCapture),
          idCode: CommonUtils.parseNumber(etiquette.idCode),
          idCodeMagasin: CommonUtils.parseNumber(etiquette.idCodeMagasin),
          idConditionnementVente: CommonUtils.parseNumber(etiquette.idConditionnementVente),
          idCongelation: CommonUtils.parseNumber(etiquette.idCongelation),
          idDenomination: CommonUtils.parseNumber(etiquette.idDenomination),
          idEau: CommonUtils.parseNumber(etiquette.idEau),
          idEsl: CommonUtils.parseNumber(etiquette.idEsl),
          idEtiquette: CommonUtils.parseNumber(etiquette.idEtiquette),
          idEtiquetteStyle: CommonUtils.parseNumber(etiquette.idEtiquetteStyle),
          idPreparation: CommonUtils.parseNumber(etiquette.idPreparation),
          idProduitLS: CommonUtils.parseNumber(etiquette.idProduitLS),
          idResultat: CommonUtils.parseNumber(etiquette.idResultat),
          idZone: CommonUtils.parseNumber(etiquette.idZone),
          lastUpdate: CommonUtils.toPostgreDatetime(etiquette.lastUpdate),
          plu: CommonUtils.parseNumber(etiquette.plu),

        }))
        commit('setEtiquettesLoading', false)
        commit('setEtiquettes', etiquetesWithCorrectType)
      })
  },
}
export default { state, actions, mutations }
